import React, { useState } from "react";
import { Select } from "antd";

const { Option } = Select;

const MaterialLikeSelect = ({ label, required, value, dropdownStyle = {}, onChange, loading, options = [], readOnly, multiple = false, allowClear = false }) => {
    const [focused, setFocused] = useState(false);

    return (
        <div className={`mui-input-container ${focused || value ? "focused" : ""}`}>
            <label className="mui-label">
                {/* {(focused || value) && required && <span className="required-star">*</span>} */}
                {required && <span className="required-star">*</span>}{label}
            </label>

            <Select
                allowClear={allowClear}
                value={value}
                loading={loading}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                disabled={readOnly}
                showSearch
                optionFilterProp="children"
                className="mui-input"
                bordered={false}
                mode={multiple ? "multiple" : undefined} // ✅ controlled mode
                style={{ width: "100%" }}

                dropdownStyle={{ borderRadius: 8, ...dropdownStyle }}
            >
                {options.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                        {opt.label}
                    </Option>
                ))}
            </Select>

            <span className="mui-underline" />
        </div>
    );
};

export default MaterialLikeSelect;
